import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_HORIZONTAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalFollowersConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.pinterest.total_followers',
    tooltip: 'kpi.pinterest.tooltip_total_followers',
    id: 'followers',
    icon: {
        name: 'followers',
        style: colors.blue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    orientation: ORIENTATION_HORIZONTAL,
    size: SIZE_33,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
